import PropTypes from 'prop-types'

/**
 * @typedef {Object} PublicIncidentComponent
 * @property {string} [group_id] - Component Group identifier
 * @property {boolean} [group] - Is this component a group
 * @property {string} [name] - Display name for component
 * @property {string[]} [subComponents] - Affected subComponents (All Links, Link 340)
 */
export const publicIncidentComponentPropType = PropTypes.shape({
    group_id: PropTypes.string,
    group: PropTypes.bool,
    name: PropTypes.string,
    subComponents: PropTypes.arrayOf(PropTypes.string)
})
